import { createI18n } from 'vue-i18n'
import messages from './messages'

export default createI18n({
  legacy: false, // you must set `false`, to use Composition API
  locale: 'en', // set locale
  fallbackLocale: 'en', // set fallback locale
  messages
})
